module.exports = __webpack_public_path__ + "static/media/Vue-SDB_07-Aigue-marine-bleu-ecume-2.1044e145.jpg";